import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS } from '@contentful/rich-text-types';

const options = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node, children) => {
			return <p className="typography typography--body-big">{children}</p>;
		},
	},
};

const TwoColumnImage = ({
	image,
	title,
	description,
	cta,
	imageAlignment,
	variant,
	titleClassName = '',
}) => {
	return (
		<div
			className={`two-column-image ${
				variant === 'With Background' ? 'with-bg' : ''
			}`}
		>
			<div
				className={`two-column-image__content bg--light-gray ${
					imageAlignment === 'right side' ? 'right-alignment' : 'left-alignment'
				}`}
			>
				<div className="two-column-image__image-wrapper">
					{/* Rendered this way not to break the component styles with the layout/styles the gatsby wrapper adds */}
					<img
						alt={image.description}
						className="two-column-image__image"
						src={image?.file?.url}
					/>
				</div>
				<div className="two-column-image__body">
					<h3
						className={`typography typography--secondary ${
							titleClassName || 'typography--h3'
						}`}
					>
						{title}
					</h3>
					<div>{renderRichText(description, options)}</div>
					<Link className="btn bg--transparent btn--outlined" to={cta?.link}>
						{cta?.title}
					</Link>
				</div>
			</div>
		</div>
	);
};

TwoColumnImage.propTypes = {
	image: PropTypes.shape({
		gatsbyImageData: PropTypes.object,
		description: PropTypes.string,
		file: PropTypes.object,
	}),
	title: PropTypes.string.isRequired,
	description: PropTypes.shape({
		raw: PropTypes.string,
	}),
	cta: PropTypes.shape({
		link: PropTypes.string,
		title: PropTypes.string,
	}),
	imageAlignment: PropTypes.string.isRequired,
	variant: PropTypes.string.isRequired,
	titleClassName: PropTypes.string,
};

export default TwoColumnImage;
